import useAuthUser from "@/composables/useAuthUser";
import useHasPermissionUser from "@/composables/useHasPermissionUser";
import { RouteRecordRaw } from "vue-router";
import EditPage from "../pages/EditPage.vue";

export default {
  path: "/internal/companies",
  children: [
    {
      path: "",
      name: "companies.index.internal",
      beforeEnter: (to, from, next) => {
        const { user } = useAuthUser();

        if (!user.value?.internal) {
          return next({
            name: "companies.index",
          });
        } else {
          return next();
        }
      },
      component: () =>
        import("@/internal/modules/companies/pages/IndexPage.vue"),
    },
    {
      path: ":name/:id",
      name: "companies.view.internal",
      beforeEnter: (to, from, next) => {
        const { user } = useAuthUser();

        if (!user.value?.internal) {
          console.log("not internal");

          return next({
            name: "companies.view",
            params: {
              name: to.params.name,
              id: to.params.id,
            },
          });
        } else {
          return next();
        }
      },
      component: () =>
        import("@/internal/modules/companies/pages/ViewPage.vue"),
    },
    {
      path: "edit/:id",
      children: [
        {
          path: "",
          name: "companies.edit.internal",
          component: EditPage,
          beforeEnter: (to, from, next) => {
            const { hasPermissionUser } = useHasPermissionUser();
            const { user } = useAuthUser();

            if (!user.value?.internal) {
              return next({
                name: "companies.edit",
                params: {
                  id: to.params.id,
                },
              });
            } else {
              return next();
            }
          },
        },
        {
          path: "/editUser/:id",
          name: "companies.edit.users.internal",
          component: () =>
            import("@/internal/modules/companies/pages/EditUserCompany.vue"),
          beforeEnter: (to, from, next) => {
            const { user } = useAuthUser();

            if (!user.value?.internal) {
              return next({
                path: "/error/not-found",
              });
            } else {
              return next();
            }
          },
        },
        {
          path: "/editAbilities/:id",
          name: "companies.edit.abilities.internal",
          component: () =>
            import("@/internal/modules/companies/pages/EditAbilitiesUser.vue"),
          beforeEnter: (to, from, next) => {
            const { user } = useAuthUser();

            if (!user.value?.internal) {
              return next({
                path: "/error/not-found",
              });
            } else {
              return next();
            }
          },
        },
        {
          path: "/editRoles/:id",
          name: "companies.edit.roles.internal",
          component: () =>
            import("@/internal/modules/companies/pages/EditRole.vue"),
          beforeEnter: (to, from, next) => {
            const { user } = useAuthUser();

            if (!user.value?.internal) {
              return next({
                path: "/error/not-found",
              });
            } else {
              return next();
            }
          },
        },
      ],
    },
    {
      path: "create/:id?",
      name: "company.create.internal",
      component: () =>
        import("@/internal/modules/companies/pages/CreatePage.vue"),
      beforeEnter: (to, from, next) => {
        const { user } = useAuthUser();

        if (!user.value?.internal) {
          return next({
            path: "/error/not-found",
          });
        } else {
          return next();
        }
      },
    },
  ],
} as RouteRecordRaw;
